import { handleActions } from 'redux-actions';

export const THEME_ACTION = 'CHECKOUT/THEME/SET';

export const reducer = handleActions(
  {
    [THEME_ACTION]: (_, action) => {
      let { variant, ...rest } = action.payload;
      if (!['bootstrap', 'standard', 'outlined', 'filled'].includes(variant)) {
        variant = 'bootstrap';
      }
      return { variant, ...rest };
    },
  },
  { variant: 'bootstrap' },
);

export default reducer;
